
import React, { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Plus, Mail } from 'lucide-react';
import { useToast } from '@/hooks/use-toast';
import InviteUserDialog from './InviteUserDialog';
import UsersTable from './UsersTable';
import { useUsers } from '@/hooks/useUsers';

const UsersSection = () => {
  const [showInviteDialog, setShowInviteDialog] = useState(false);
  const { users, isLoading, inviteUser, removeUser } = useUsers();
  const { toast } = useToast();

  const handleInvite = async (data: { email: string; role: string; name: string }) => {
    try {
      await inviteUser(data);
      toast({
        title: "Invitation sent",
        description: `Invitation has been sent to ${data.email}`,
      });
      setShowInviteDialog(false);
    } catch (error) {
      toast({
        title: "Error",
        description: "Failed to send invitation",
        variant: "destructive",
      });
    }
  };

  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between">
        <CardTitle>Users</CardTitle>
        <Button 
          onClick={() => setShowInviteDialog(true)}
          className="flex items-center gap-2"
        >
          <Mail className="h-4 w-4" />
          Invite User
        </Button>
      </CardHeader>
      <CardContent>
        <UsersTable 
          users={users} 
          isLoading={isLoading} 
          onRemove={removeUser}
        />
      </CardContent>

      <InviteUserDialog
        open={showInviteDialog}
        onClose={() => setShowInviteDialog(false)}
        onInvite={handleInvite}
      />
    </Card>
  );
};

export default UsersSection;
